import { createSagaMiddleware } from 'async-saga';
import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, createStore, PreloadedState } from 'redux';
import { createLogger } from 'redux-logger';
import { getType } from 'typesafe-actions';
import * as actions from './actions';
import { createRootReducer } from './reducers';
import rootHandler from './sagas';
import { apiMiddleware } from './tools/async-saga-types';
import { Actions, StoreState } from './types';

const skipLog = [ actions.setNow, actions.setIdleSeconds ].map<string>(a => getType(a));

const loggerMiddleware = createLogger({
  predicate: (getState, action: Actions) => !skipLog.includes(action.type),
})

const sagas = createSagaMiddleware(rootHandler)

export function configureStore(preloadedState: PreloadedState<StoreState>, history: History) {
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    applyMiddleware(
      apiMiddleware,
      loggerMiddleware,
      routerMiddleware(history),
      sagas,
    ),
  );

  sagas.run()

  return store;
}

export { actions };

